export const navLinks = [
  { label: '首页', href: '#hero' },
  { label: '热门话题', href: '#topics' },
  { label: '站点排行', href: '#ranking' },
  { label: '关于本站', href: '#about' },
  { label: '最新动态', href: '#updates' },
];

export const carouselItems = [
  {
    id: 1,
    tag: '热门推荐',
    title: '91黑料在线 — 社区热议焦点内容聚合',
    summary: '汇集全网热门讨论帖与高质量内容源，覆盖娱乐、社会、行业等多元话题，每日更新推送，不遗漏任何值得关注的黑料动态。',
    image: 'https://readdy.ai/api/search-image?query=A%20bold%20editorial%20composition%20with%20warm%20dark%20crimson%20and%20charcoal%20tones%2C%20featuring%20stylized%20abstract%20newspaper%20collage%20elements%2C%20dynamic%20diagonal%20lines%2C%20modern%20graphic%20design%20aesthetic%2C%20dramatic%20lighting%2C%20high%20contrast%2C%20sophisticated%20texture%20overlay&width=800&height=480&seq=carousel-01&orientation=landscape',
    alt: '91黑料在线专题封面',
  },
  {
    id: 2,
    tag: '编辑精选',
    title: '51黑料在线 — 独家深度爆料内容平台',
    summary: '专注独家爆料与深度追踪报道，提供第一手信息来源与多角度分析，为追求真实内容的用户打造可信赖的内容入口。',
    image: 'https://readdy.ai/api/search-image?query=A%20dark%20moody%20editorial%20layout%20with%20layered%20paper%20textures%2C%20burning%20amber%20accent%20highlights%2C%20mysterious%20atmosphere%2C%20modern%20magazine%20spread%20style%2C%20warm%20crimson%20undertones%2C%20artistic%20composition%20with%20negative%20space&width=800&height=480&seq=carousel-02&orientation=landscape',
    alt: '51黑料在线专题封面',
  },
  {
    id: 3,
    tag: '视频专区',
    title: '黑料视频合集 — 多维度视觉内容呈现',
    summary: '整合各类视频内容资源，以直观的视觉形式呈现热门话题与深度内容，支持多平台内容源聚合浏览。',
    image: 'https://readdy.ai/api/search-image?query=A%20cinematic%20dark%20aesthetic%20with%20film%20strip%20elements%2C%20warm%20golden%20accents%20on%20deep%20charcoal%20background%2C%20abstract%20motion%20blur%20effects%2C%20modern%20editorial%20photography%20style%2C%20dramatic%20contrast%20lighting%2C%20sophisticated%20design&width=800&height=480&seq=carousel-03&orientation=landscape',
    alt: '黑料视频合集专题封面',
  },
  {
    id: 4,
    tag: '娱乐聚焦',
    title: '娱乐爆料专题 — 明星八卦与圈内动态',
    summary: '聚焦娱乐圈最新动态，汇总权威爆料渠道与热门讨论帖，提供全方位娱乐资讯入口与内容导航服务。',
    image: 'https://readdy.ai/api/search-image?query=A%20theatrical%20dramatic%20composition%20with%20deep%20red%20velvet%20textures%2C%20spotlight%20effects%20on%20dark%20stage%2C%20mysterious%20glamorous%20atmosphere%2C%20editorial%20magazine%20photography%2C%20warm%20golden%20highlights%2C%20cinematic%20mood&width=800&height=480&seq=carousel-04&orientation=landscape',
    alt: '娱乐爆料专题封面',
  },
  {
    id: 5,
    tag: '社会观察',
    title: '社会热点追踪 — 实时事件与深度解读',
    summary: '追踪社会热点事件，整合多方信息源与深度分析内容，为用户提供全面的事件脉络与讨论入口。',
    image: 'https://readdy.ai/api/search-image?query=A%20journalistic%20dark%20composition%20with%20abstract%20map%20and%20data%20visualization%20elements%2C%20warm%20crimson%20and%20charcoal%20color%20palette%2C%20modern%20infographic%20style%2C%20dramatic%20contrast%2C%20sophisticated%20editorial%20design&width=800&height=480&seq=carousel-05&orientation=landscape',
    alt: '社会热点追踪专题封面',
  },
];

export const topicItems = [
  { id: 1, name: '黑料网站', heat: '9.8万', icon: 'ri-fire-line' },
  { id: 2, name: '黑料在线', heat: '8.5万', icon: 'ri-flashlight-line' },
  { id: 3, name: '91黑料在线', heat: '7.2万', icon: 'ri-star-line' },
  { id: 4, name: '51黑料在线', heat: '6.8万', icon: 'ri-thumb-up-line' },
  { id: 5, name: '娱乐爆料', heat: '9.1万', icon: 'ri-movie-line' },
  { id: 6, name: '社会热点', heat: '8.3万', icon: 'ri-global-line' },
  { id: 7, name: '网站推荐', heat: '5.6万', icon: 'ri-compass-line' },
  { id: 8, name: '资源导航', heat: '6.2万', icon: 'ri-guide-line' },
  { id: 9, name: '站点评测', heat: '4.7万', icon: 'ri-survey-line' },
  { id: 10, name: '内容合集', heat: '5.9万', icon: 'ri-folder-line' },
];

export const appData = {
  title: '黑料导航 · 移动端',
  subtitle: '随时随地浏览最新黑料资源',
  description: '覆盖主流黑料网站与在线平台，支持一键跳转、收藏管理与个性化推荐。聚合全网优质内容源，让你不错过任何值得关注的黑料动态。',
  features: ['全平台内容聚合', '实时更新推送', '智能推荐算法', '安全隐私保护'],
  image: 'https://readdy.ai/api/search-image?query=A%20modern%20dark%20mode%20mobile%20app%20interface%20mockup%20floating%20on%20a%20dark%20gradient%20background%2C%20sleek%20UI%20with%20warm%20crimson%20accent%20elements%2C%20card%20based%20layout%2C%20minimalist%20design%2C%20premium%20tech%20aesthetic%2C%20soft%20glow%20effects&width=600&height=800&seq=app-section-01&orientation=portrait',
  alt: '黑料导航移动端截图',
};

export const mediaItems = [
  {
    id: 1,
    tag: '热门视频',
    title: '本周最受关注的黑料话题深度解析',
    duration: '12:36',
    source: '综合整理',
    views: '8.2万',
    image: 'https://readdy.ai/api/search-image?query=A%20dark%20cinematic%20video%20thumbnail%20style%20with%20warm%20crimson%20gradient%20overlay%2C%20abstract%20geometric%20patterns%2C%20modern%20YouTube%20thumbnail%20aesthetic%2C%20dramatic%20lighting%2C%20bold%20composition&width=640&height=400&seq=media-01&orientation=landscape',
  },
  {
    id: 2,
    tag: '深度分析',
    title: '黑料网站大全：如何筛选高质量内容源',
    duration: '18:42',
    source: '编辑团队',
    views: '6.7万',
    image: 'https://readdy.ai/api/search-image?query=A%20sophisticated%20dark%20editorial%20video%20frame%20with%20warm%20amber%20glow%2C%20magnifying%20glass%20and%20data%20screen%20elements%2C%20investigative%20journalism%20aesthetic%2C%20modern%20minimal%20design%20with%20rich%20textures&width=640&height=400&seq=media-02&orientation=landscape',
  },
  {
    id: 3,
    tag: '专题报道',
    title: '91黑料在线与51黑料在线的内容对比评测',
    duration: '15:08',
    source: '评测团队',
    views: '9.4万',
    image: 'https://readdy.ai/api/search-image?query=A%20comparison%20split%20screen%20dark%20editorial%20composition%2C%20warm%20crimson%20versus%20cool%20amber%20split%20tones%2C%20modern%20review%20style%20layout%2C%20professional%20video%20production%20aesthetic%2C%20clean%20graphic%20elements&width=640&height=400&seq=media-03&orientation=landscape',
  },
];

export const contactData = {
  title: '一起建设黑料资源生态',
  subtitle: '站点提交 · 问题反馈 · 商务合作',
  description: '如果您有优质的黑料网站资源推荐，或在使用过程中遇到任何问题，欢迎通过以下方式与我们取得联系。我们珍视每一份用户反馈与合作伙伴关系。',
  channels: [
    { icon: 'ri-mail-line', label: '站点提交', desc: '推荐优质黑料网站资源' },
    { icon: 'ri-question-answer-line', label: '问题反馈', desc: '意见与使用问题反馈' },
    { icon: 'ri-service-line', label: '商务合作', desc: '广告投放与品牌合作' },
  ],
};

export const commentItems = [
  {
    id: 1,
    name: '老司机阿强',
    avatar: 'https://readdy.ai/api/search-image?query=A%20stylized%20minimal%20dark%20avatar%20with%20warm%20tones%2C%20abstract%20face%20silhouette%2C%20modern%20profile%20picture%20style%2C%20charcoal%20background&width=80&height=80&seq=avatar-01&orientation=squarish',
    date: '2天前',
    content: '用了黑料官网好几个月了，收录的黑料网站真的很全，更新也及时，帮我省了不少找站的时间。推荐给朋友了！',
    rating: 5,
  },
  {
    id: 2,
    name: '吃瓜第一线',
    avatar: 'https://readdy.ai/api/search-image?query=A%20stylized%20minimal%20dark%20avatar%20with%20crimson%20accent%2C%20abstract%20face%20silhouette%2C%20modern%20profile%20picture%20style%2C%20dark%20background&width=80&height=80&seq=avatar-02&orientation=squarish',
    date: '5天前',
    content: '51黑料在线的推荐非常靠谱，内容质量确实比其他导航站筛选得好，每天必刷。希望继续保持！',
    rating: 5,
  },
  {
    id: 3,
    name: '匿名用户',
    avatar: 'https://readdy.ai/api/search-image?query=A%20stylized%20minimal%20dark%20avatar%20with%20amber%20warmth%2C%20abstract%20face%20silhouette%2C%20modern%20profile%20picture%20style%2C%20neutral%20background&width=80&height=80&seq=avatar-03&orientation=squarish',
    date: '1周前',
    content: '黑料网导航做得挺用心的，分类清晰，排行榜也实用。就是希望手机版体验能再优化一下。',
    rating: 4,
  },
  {
    id: 4,
    name: '深度观察者',
    avatar: 'https://readdy.ai/api/search-image?query=A%20stylized%20minimal%20dark%20avatar%20with%20warm%20gold%20glow%2C%20abstract%20face%20silhouette%2C%20modern%20profile%20picture%20style%2C%20dark%20background&width=80&height=80&seq=avatar-04&orientation=squarish',
    date: '1周前',
    content: '91黑料在线的内容聚合做得很不错，再加上这里的导航，基本上所有想看的内容都能快速找到入口。推荐！',
    rating: 5,
  },
];

export const rankingItems = [
  {
    rank: 1,
    name: '91黑料在线',
    tag: '热门',
    description: '国内最活跃的黑料内容社区平台，日活用户超百万，话题更新频率极高',
    heat: '🔥 9.8万',
  },
  {
    rank: 2,
    name: '51黑料在线',
    tag: '新锐',
    description: '以独家深度爆料内容著称，内容质量广受好评，用户增长迅速',
    heat: '🔥 8.5万',
  },
  {
    rank: 3,
    name: '黑料网导航总站',
    tag: '推荐',
    description: '一站式黑料网站导航入口，收录站点覆盖全面，分类清晰易用',
    heat: '🔥 7.2万',
  },
  {
    rank: 4,
    name: '吃瓜社区',
    tag: '活跃',
    description: '以娱乐八卦与社会热点讨论为主，社区氛围活跃，互动频率高',
    heat: '🔥 6.6万',
  },
  {
    rank: 5,
    name: '爆料前线',
    tag: '新站',
    description: '新兴黑料内容站点，以实时推送与简洁界面受到年轻用户青睐',
    heat: '🔥 5.3万',
  },
];

export const aboutData = {
  title: '关于黑料官网',
  paragraphs: [
    '黑料官网诞生于对优质黑料内容资源的系统性整理需求。我们致力于为用户提供最全面、最可靠的黑料网站导航与内容聚合服务，帮助每一位寻找黑料在线资源的用户快速找到值得信赖的内容入口。',
    '从91黑料在线到51黑料在线，从热门社区到新兴站点，我们的团队持续追踪全网黑料内容生态的变化，精心筛选并整理每一份推荐。我们理解用户对内容质量与访问安全的核心诉求，因此在收录每个站点前都会经过多维度评估。',
    '黑料官网不仅是一个导航工具，更是一个连接用户与优质内容的桥梁。无论你是想快速了解当日热点，还是希望深入探索特定话题，这里都能为你提供清晰的内容路径。',
    '我们秉持客观、全面的收录原则，不偏袒任何单一平台，只以内容质量为唯一标准。持续更新、持续优化，是我们对每一位用户的承诺。',
  ],
  stats: [
    { value: '200+', label: '收录站点' },
    { value: '50万+', label: '月活用户' },
    { value: '99.9%', label: '服务可用率' },
    { value: '每日', label: '内容更新' },
  ],
};

export const featureItems = [
  {
    id: 1,
    icon: 'ri-shield-check-line',
    title: '严格筛选',
    description: '每个收录的黑料网站均经过人工审核与多维度评估，确保内容质量与访问安全性，杜绝低质与恶意站点。',
  },
  {
    id: 2,
    icon: 'ri-refresh-line',
    title: '实时更新',
    description: '黑料在线资源库每日同步更新，第一时间反映站点状态变化，确保导航信息始终准确有效。',
  },
  {
    id: 3,
    icon: 'ri-stack-line',
    title: '分类明确',
    description: '按内容类型、热度、更新频率等多维度分类整理，用户可快速定位感兴趣的黑料网站资源。',
  },
  {
    id: 4,
    icon: 'ri-user-heart-line',
    title: '用户导向',
    description: '基于真实用户反馈持续优化推荐算法与导航体验，让黑料网导航更贴合实际使用需求。',
  },
  {
    id: 5,
    icon: 'ri-eye-off-line',
    title: '隐私保护',
    description: '不追踪用户浏览行为，不收集个人信息，提供纯净的浏览体验，保护每一位用户的上网隐私。',
  },
];

export const cardItems = [
  {
    id: 1,
    tag: '编辑推荐',
    title: '2024年度黑料网站大全精选',
    summary: '综合内容质量、更新频率与用户口碑，精选本年度最值得关注的黑料网站资源合集。',
    image: 'https://readdy.ai/api/search-image?query=A%20dark%20editorial%20composition%20with%20golden%20trophy%20and%20ribbon%20elements%20on%20rich%20charcoal%20background%2C%20award%20ceremony%20aesthetic%2C%20warm%20crimson%20accents%2C%20premium%20magazine%20layout%20style&width=640&height=420&seq=card-01&orientation=landscape',
    alt: '2024年度黑料网站大全精选',
    link: '#cards',
  },
  {
    id: 2,
    tag: '新手指南',
    title: '黑料网推荐：从零开始的资源探索之路',
    summary: '面向新用户的完整入门指南，介绍主流黑料在线平台特点与使用技巧。',
    image: 'https://readdy.ai/api/search-image?query=A%20dark%20warm%20toned%20compass%20and%20map%20inspired%20editorial%20image%2C%20exploration%20theme%2C%20modern%20graphic%20design%2C%20amber%20highlights%20on%20deep%20charcoal%2C%20mysterious%20adventure%20aesthetic&width=640&height=420&seq=card-02&orientation=landscape',
    alt: '黑料网推荐入门指南',
    link: '#cards',
  },
  {
    id: 3,
    tag: '深度评测',
    title: '91黑料在线 vs 51黑料在线：全面对比',
    summary: '从内容质量、社区氛围、更新速度等多维度对比两大主流黑料内容平台。',
    image: 'https://readdy.ai/api/search-image?query=A%20versus%20style%20dark%20editorial%20layout%20with%20split%20warm%20crimson%20and%20cool%20amber%20tones%2C%20comparison%20infographic%20aesthetic%2C%20modern%20magazine%20design%2C%20dramatic%20contrast&width=640&height=420&seq=card-03&orientation=landscape',
    alt: '91黑料在线与51黑料在线对比',
    link: '#cards',
  },
  {
    id: 4,
    tag: '趋势分析',
    title: '2024黑料内容生态趋势观察报告',
    summary: '分析当前黑料内容领域的发展趋势、热门话题方向与用户行为变化。',
    image: 'https://readdy.ai/api/search-image?query=A%20dark%20sophisticated%20data%20visualization%20aesthetic%20with%20rising%20graph%20lines%2C%20warm%20golden%20accents%2C%20modern%20business%20report%20style%2C%20charcoal%20background%20with%20crimson%20highlights&width=640&height=420&seq=card-04&orientation=landscape',
    alt: '黑料内容生态趋势观察',
    link: '#cards',
  },
  {
    id: 5,
    tag: '安全指南',
    title: '安全浏览黑料网站：实用防护建议',
    summary: '在使用黑料在线资源时需要注意的安全事项与隐私保护实用建议。',
    image: 'https://readdy.ai/api/search-image?query=A%20dark%20shield%20and%20lock%20inspired%20editorial%20composition%2C%20cybersecurity%20aesthetic%20with%20warm%20amber%20glow%2C%20modern%20minimal%20design%2C%20protective%20atmosphere%2C%20deep%20charcoal%20background&width=640&height=420&seq=card-05&orientation=landscape',
    alt: '安全浏览黑料网站指南',
    link: '#cards',
  },
  {
    id: 6,
    tag: '社区精选',
    title: '黑料网合集：用户票选最佳内容源',
    summary: '基于真实用户投票数据整理的黑料网站合集，反映社区最受欢迎的内容入口。',
    image: 'https://readdy.ai/api/search-image?query=A%20dark%20community%20voting%20themed%20editorial%20image%20with%20stars%20and%20badges%2C%20warm%20crimson%20and%20gold%20accents%2C%20modern%20magazine%20spread%2C%20premium%20design%20aesthetic&width=640&height=420&seq=card-06&orientation=landscape',
    alt: '黑料网合集用户票选',
    link: '#cards',
  },
  {
    id: 7,
    tag: '更新速递',
    title: '本周黑料网站大全更新日志',
    summary: '每周更新站点收录情况，新增优质站点介绍与失效站点清理公示。',
    image: 'https://readdy.ai/api/search-image?query=A%20dark%20newspaper%20and%20update%20log%20themed%20editorial%20image%2C%20warm%20amber%20highlights%2C%20modern%20typography%20elements%2C%20journalistic%20aesthetic%2C%20charcoal%20background&width=640&height=420&seq=card-07&orientation=landscape',
    alt: '本周黑料网站大全更新日志',
    link: '#cards',
  },
];

export const faqItems = [
  {
    id: 1,
    question: '黑料官网收录黑料网站的标准是什么？',
    answer: '我们有一套多维度的评估体系：首先考察内容质量与更新频率，确保站点有持续产出优质内容的能力；其次评估社区活跃度与用户口碑；最后检查访问稳定性与安全性。只有通过全部评估维度的站点才会被收录进黑料网站大全。',
  },
  {
    id: 2,
    question: '91黑料在线和51黑料在线有什么区别？',
    answer: '91黑料在线以社区讨论和用户UGC内容为主，话题覆盖面广，更新频率极高，适合喜欢参与讨论的用户。51黑料在线则更侧重独家爆料与深度内容，信息经过更多筛选和整理，适合追求内容质量的用户。两者各有特色，建议根据个人需求选择。',
  },
  {
    id: 3,
    question: '如何推荐新的黑料网站加入导航？',
    answer: '你可以通过本站联系页面的「站点提交」通道向我们推荐优质的黑料网站资源。我们的审核团队会在3个工作日内完成初步评估，并通过邮件反馈审核结果。欢迎各位用户积极参与，共同丰富黑料内容生态。',
  },
  {
    id: 4,
    question: '黑料官网是否需要注册才能使用？',
    answer: '完全不需要。黑料官网对所有用户免费开放，无需注册、无需登录即可浏览全部黑料网站导航与内容资源。我们不收集用户的个人信息，也不追踪浏览行为，提供纯粹、安全的浏览体验。',
  },
];

export const updateItems = [
  {
    id: 1,
    date: '2024-07-30',
    tag: '站点更新',
    title: '本周新增5个优质黑料网站收录，更新了3个站点的状态信息',
  },
  {
    id: 2,
    date: '2024-07-28',
    tag: '功能优化',
    title: '黑料网导航分类体系优化升级，新增「视频内容」与「社区讨论」两个分类',
  },
  {
    id: 3,
    date: '2024-07-25',
    tag: '内容发布',
    title: '发布《2024上半年黑料网站大全精选合集》，收录50个优质黑料在线平台',
  },
  {
    id: 4,
    date: '2024-07-22',
    tag: '站点更新',
    title: '91黑料在线专区完成内容刷新，新增最新热门话题与讨论帖索引',
  },
  {
    id: 5,
    date: '2024-07-18',
    tag: '用户反馈',
    title: '根据社区建议优化了移动端黑料网导航页面，提升触屏操作体验',
  },
  {
    id: 6,
    date: '2024-07-15',
    tag: '合作公告',
    title: '与多个优质内容平台达成合作意向，后续将引入更多独家黑料在线资源',
  },
  {
    id: 7,
    date: '2024-07-10',
    tag: '站点更新',
    title: '51黑料在线专区上线，汇总该平台近期最受关注的爆料内容与讨论帖',
  },
  {
    id: 8,
    date: '2024-07-05',
    tag: '安全公告',
    title: '完成全站安全审计，升级了站点审核与用户隐私保护机制',
  },
  {
    id: 9,
    date: '2024-07-01',
    tag: '月度总结',
    title: '6月黑料网站大全访问量突破50万，感谢每一位用户的支持与信任',
  },
];

export const indexItems = [
  {
    id: 1,
    letter: 'A',
    title: '91黑料在线专区',
    count: '15个站点',
    description: '围绕91黑料在线相关的全部内容入口与资源链接',
  },
  {
    id: 2,
    letter: 'B',
    title: '51黑料在线推荐',
    count: '12个站点',
    description: '51黑料在线平台相关的优质内容源与导航入口',
  },
  {
    id: 3,
    letter: 'C',
    title: '娱乐爆料合集',
    count: '28个站点',
    description: '聚焦娱乐圈明星八卦与行业动态的内容站点汇总',
  },
  {
    id: 4,
    letter: 'D',
    title: '社会热点追踪',
    count: '22个站点',
    description: '追踪社会事件与热门讨论的内容平台资源索引',
  },
  {
    id: 5,
    letter: 'E',
    title: '视频内容专区',
    count: '18个站点',
    description: '各类黑料视频内容的聚合入口与资源导航',
  },
  {
    id: 6,
    letter: 'F',
    title: '社区讨论导航',
    count: '20个站点',
    description: '活跃的黑料讨论社区与论坛入口大全',
  },
  {
    id: 7,
    letter: 'G',
    title: '深度报道索引',
    count: '14个站点',
    description: '专注深度报道与独家爆料的优质内容站点导航',
  },
  {
    id: 8,
    letter: 'H',
    title: '综合导航总站',
    count: '32个站点',
    description: '涵盖各类黑料内容的一站式综合导航入口合集',
  },
];

export const footerData = {
  description: '黑料官网 — 最全面的黑料网站导航与黑料在线资源聚合平台。收录91黑料在线、51黑料在线等优质黑料内容站点，提供黑料网站大全、黑料网推荐、黑料网排行、黑料网合集与黑料网导航服务。每日更新，安全可靠。',
  quickLinks: [
    { label: '热门话题', href: '#topics' },
    { label: '站点排行', href: '#ranking' },
    { label: '关于本站', href: '#about' },
    { label: '最新动态', href: '#updates' },
    { label: '常见问答', href: '#faq' },
    { label: '主题索引', href: '#index' },
  ],
};